import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBranch } from '../contexts/BranchContext';

export const SHIFT_LANDING_KEY = 'shiftLandingChecked';

const markChecked = () => {
  try { sessionStorage.setItem(SHIFT_LANDING_KEY, '1'); } catch { /* private mode — เช็คซ้ำตอนโหลดหน้าใหม่ได้ ไม่เสียหาย */ }
};

/**
 * หน้าแรกของการใช้งานต้องเป็น "เปิดร้าน" — ถ้าเข้าแอปที่หน้าแรก ("/") แล้วสาขานี้ยังไม่มีกะเงินทอนที่เปิดอยู่
 * พาไปหน้า /cash-drawer ให้นับเงินตั้งต้นก่อน
 *
 * ตั้งใจให้เกิด "ครั้งเดียวต่อการล็อกอิน" (sessionStorage) และเฉพาะตอนลงหน้าแรก ไม่ใช่ล็อกทุกหน้า:
 *  - Dashboard/รายงานต้องเข้าได้ตอนร้านปิด (เจ้าของเปิดดูยอดตอนดึก) จึงไม่บังคับทุกครั้งที่กลับมาหน้าแรก
 *  - ลิงก์ตรงไปหน้าอื่น (เช่น /checkout) ไม่โดนดึงกลับ
 *  - ตรวจกะไม่ได้ (ออฟไลน์/เซิร์ฟเวอร์ล่ม/เลือกรวมทุกสาขา) = ปล่อยผ่าน ไม่ขวางการขาย
 */
export default function ShiftLandingRedirect({ apiUrl }) {
  const { loading, isAllBranches, effectiveBranchId } = useBranch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let alreadyChecked = false;
    try { alreadyChecked = sessionStorage.getItem(SHIFT_LANDING_KEY) === '1'; } catch { /* ถือว่ายังไม่เช็ค */ }
    if (alreadyChecked || loading) return;

    // ลงที่หน้าอื่นที่ไม่ใช่หน้าแรก = ไม่ยุ่ง และไม่ตามมาเช็คทีหลังด้วย
    if (location.pathname !== '/') {
      markChecked();
      return;
    }
    // ยังไม่รู้ว่าสาขาไหน (รวมทุกสาขา/ยังโหลดสาขาไม่เสร็จ) — รอ ไม่เดา
    if (isAllBranches || !effectiveBranchId) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${apiUrl}/api/cash-drawer/current`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` }
        });
        if (!res.ok) return;
        const body = await res.json();
        if (cancelled) return;
        markChecked();
        if (!body.data?.session) navigate('/cash-drawer', { replace: true });
      } catch {
        /* ออฟไลน์ — ปล่อยผ่าน */
      }
    })();
    return () => { cancelled = true; };
  }, [loading, isAllBranches, effectiveBranchId, location.pathname, apiUrl, navigate]);

  return null;
}
